import {
	FileImageOutlined,
	VideoCameraOutlined,
	FilePdfOutlined,
} from "@ant-design/icons";
import { Alert, Form, Input, Modal, Select } from "antd";
import React, { useEffect, useState } from "react";
import ReactQuill from "react-quill";
import { api } from "services/api";
import { IEditBlocks } from "types";
import { formatUrl } from "utils";
import Swal from "sweetalert2";

const types = [
	{
		value: "",
		label: "Selecione o tipo",
	},
	{
		value: "text",
		label: "Textual",
	},
	{
		value: "image",
		label: "Imagem",
	},
	{
		value: "youtube",
		label: "Youtube",
	},
	{
		value: "vimeo",
		label: "Vimeo",
	},
	{
		value: "archive",
		label: "Arquivo",
	},
];

export const EditBlockContentModal: React.FC<IEditBlocks> = ({ ...props }) => {
	const {
		form,
		isOpen,
		setFiles,
		setIsOpen,
		setEditMode,
		files,
		setProcessing,
		setBlocks,
		blocks,
		fromCreate,
		setFromCreate,
		selectedBlockId,
	} = props;
	const [order, setOrder] = useState<number>(0);
	const [value, setValue] = useState<string>("");
	const [blockType, setBlockType] = useState<string>("text");
	const [error, setError] = useState<string>("");

	const handleSave = async (data: { [k: string]: string }) => {
		// if (blockType === "youtube" || blockType === "vimeo") {
		// 	if (!validateUrl(value)) {
		// 		setError("Informe uma url válida");
		// 		return;
		// 	}
		// }
		if (value.length === 0) {
			setError("Informe o conteúdo do bloco");
			return;
		}

		if (fromCreate) {
			setProcessing(true);
			setBlocks((prevState) => {
				prevState[selectedBlockId] = {
					...prevState[selectedBlockId],
					type: blockType,
					order: order,
					content:
						blockType !== "text"
							? blockType !== "youtube"
								? blockType !== "vimeo"
									? files[blockType]
									: formatUrl(value)
								: formatUrl(value)
							: value,
				};
				return prevState;
			});
			setFromCreate(false);
			setBlockType("");
			setValue("");
			setOrder(0);
			setFiles({ image: "", video: "", archive: "" });
			setProcessing(false);
		} else {
			const sendData = {
				class_id: data.class_id,
				order: order,
				type: blockType,
				content:
					blockType !== "text"
						? blockType !== "youtube"
							? blockType !== "vimeo"
								? files[blockType]
								: formatUrl(value)
							: formatUrl(value)
						: value,
			};

			setProcessing(true);
			await api
				.put(`/blocks/${data.id}`, sendData)
				.then((res) => {
					const { type, order, content } = res.data.data.block;

					setProcessing(false);

					handleReset();
					setBlocks((prevState) => {
						prevState[selectedBlockId] = {
							...prevState[selectedBlockId],
							type: type,
							order: order,
							content: content,
						};
						return prevState;
					});
				})
				.catch((err) => {
					setProcessing(false);
					const status = err.response.status;
					const { feedback, errors } = err.response?.data;
					if (
						status === 400 ||
						status === 401 ||
						status === 404 ||
						status === 403 ||
						status === 500
					) {
						Swal.fire({
							icon: "error",
							text: feedback["error"]
								? feedback["error"]
								: "Desculpe, ocorreu algum problema =( Por favor tente novamente",
						});
						const html = document.getElementsByTagName("html");
						html.item(0)?.classList.remove("swal2-shown", "swal2-height-auto");
						document.body.classList.remove("swal2-shown", "swal2-height-auto");
					}
					if (status === 422) {
						Swal.fire({
							icon: "error",
							text: errors?.message
								? errors?.message
								: "Desculpe, ocorreu algum problema =( Por favor tente novamente",
						});
						const html = document.getElementsByTagName("html");
						html.item(0)?.classList.remove("swal2-shown", "swal2-height-auto");
						document.body.classList.remove("swal2-shown", "swal2-height-auto");
					}
				});
		}
		setIsOpen(!isOpen);
		setEditMode(false);
	};

	const handleSelectChange = (value: string) => {
		setBlockType(value);
	};

	const handleReset = () => {
		setValue("");
		setBlockType("");
		setOrder(0);
		setFiles({ image: "", video: "", archive: "" });
	};

	useEffect(() => {
		if (blocks[selectedBlockId] && blocks[selectedBlockId]?.type) {
			console.log(blocks[selectedBlockId]);
			setOrder(blocks[selectedBlockId]?.order);
			setBlockType(blocks[selectedBlockId]?.type);
			setValue(blocks[selectedBlockId]?.content);
		}
	}, [blocks, selectedBlockId]);

	return (
		<Modal
			title={<p style={{ margin: 0 }}>Editar bloco de conteúdo</p>}
			open={isOpen}
			maskClosable={false}
			okText="Editar bloco"
			cancelText="Cancelar"
			onOk={() => {
				handleSave(blocks[selectedBlockId]);
			}}
			onCancel={() => {
				setIsOpen(!isOpen);
				handleReset();
			}}
			zIndex={1050}
			className="m-modal-courses"
		>
			<Form form={form} name="new-course" autoComplete="off">
				<div className="m-modules-modal">
					<div className="">
						<label>Ordem</label>
						<Input
							id="order"
							type="number"
							value={order}
							min={1}
							onChange={(e) => {
								setOrder(Number(e.target.value));
							}}
						/>
					</div>
					<div
						className="m-modules-modal__login-info"
						style={{ marginTop: "20px" }}
					>
						<div
							className="m-modules-modal__login-info__inputs"
							style={{ justifyContent: "space-evenly", height: "fit-content" }}
						>
							<div
								style={{ display: "flex", width: "100%", alignItems: "center" }}
							>
								<Select
									placeholder="Tipo de bloco"
									defaultValue={""}
									value={blockType}
									className="m-modules-modal__select"
									onChange={handleSelectChange}
									options={types}
								/>
							</div>
						</div>
					</div>
					{error && (
						<div className="m-modules-modal__error">
							<Alert
								message={error}
								type="error"
								showIcon
								closable
								onClose={() => setError("")}
							/>
						</div>
					)}
					<div
						className="m-modules-modal__textarea"
						style={{ marginTop: "20px" }}
					>
						{blockType === "text" && (
							<ReactQuill
								theme="snow"
								value={value ? value : blocks[selectedBlockId]?.content}
								onChange={setValue}
							/>
						)}
						{blockType === "image" && (
							<div
								className="m-classes-modal__login-info__avatar"
								style={{
									width: "80%",
									height: "100%",
									display: "flex",
									alignItems: "center",
									margin: "0 auto",
									justifyContent: "center",
								}}
							>
								{files.image ? (
									<img src={files.image} alt="" width="50%" height="100%" />
								) : blocks[selectedBlockId].type === "image" ? (
									<img
										src={blocks[selectedBlockId].content}
										alt=""
										width="50%"
										height="100%"
									/>
								) : (
									<FileImageOutlined />
								)}
								<label
									htmlFor="image"
									className="m-classes-modal__login-info__avatar__btn"
									style={{ width: "50%" }}
								>
									Enviar foto
								</label>
								<Input
									id="image"
									type="file"
									name="image"
									accept="image/*"
									style={{ display: "none" }}
									onChange={(e) =>
										setFiles((prevState) => ({
											...prevState,
											// eslint-disalbe-next-line
											// @ts-ignore
											image: URL.createObjectURL(e.target.files?.[0]),
										}))
									}
								/>
							</div>
						)}
						{blockType === "youtube" && (
							<div>
								<label>Url do Vídeo</label>
								{/* {error && <p style={{ color: "red", fontSize: 11 }}>{error}</p>} */}
								<Input
									id="youtube"
									type="text"
									value={value}
									onChange={(e) => {
										setValue(e.target.value);
									}}
								/>
							</div>
						)}
						{blockType === "vimeo" && (
							<div>
								<label>Url do Vídeo</label>
								{/* {error && <p style={{ color: "red", fontSize: 11 }}>{error}</p>} */}
								<Input
									id="vimeo"
									type="text"
									value={value}
									onChange={(e) => {
										setValue(e.target.value);
									}}
								/>
							</div>
						)}
						{blockType === "video" && (
							<div
								className="m-classes-modal__login-info__avatar"
								style={{
									width: "80%",
									height: "100%",
									display: "flex",
									alignItems: "center",
									margin: "0 auto",
									justifyContent: "center",
								}}
							>
								{files.video ? (
									<video width="100%" height="100%" controls>
										<source src={files.video} type="video/mp4" />
									</video>
								) : blocks[selectedBlockId]?.type === "video" ? (
									<video width="100%" height="100%" controls>
										<source
											src={blocks[selectedBlockId]?.content}
											type="video/mp4"
										/>
									</video>
								) : (
									<VideoCameraOutlined />
								)}
								<label
									htmlFor="video"
									className="m-classes-modal__login-info__avatar__btn"
									style={{ width: "50%" }}
								>
									Enviar vídeo
								</label>
								<Input
									id="video"
									type="file"
									accept="video/mp4,video/x-m4v,video/*"
									style={{ display: "none" }}
									onChange={(e) =>
										setFiles((prevState) => ({
											...prevState,
											// eslint-disalbe-next-line
											// @ts-ignore
											video: URL.createObjectURL(e.target.files?.[0]),
										}))
									}
								/>
							</div>
						)}
						{blockType === "archive" && (
							<div
								className="m-classes-modal__login-info__avatar"
								style={{
									width: "80%",
									height: "100%",
									display: "flex",
									alignItems: "center",
									margin: "0 auto",
									justifyContent: "center",
								}}
							>
								{files.archive ? (
									<a href={files.archive} target="_blank" rel="noreferrer">
										Ver Arquivo
									</a>
								) : blocks[selectedBlockId].type === "file" ? (
									<a
										href={blocks[selectedBlockId].content}
										target="_blank"
										rel="noreferrer"
									>
										{blocks[selectedBlockId].content}
									</a>
								) : (
									<FilePdfOutlined />
								)}
								<label
									htmlFor="file"
									className="m-classes-modal__login-info__avatar__btn"
									style={{ width: "50%" }}
								>
									Enviar arquivo
								</label>
								<Input
									id="file"
									type="file"
									name="archive"
									accept=".pdf,.doc,.docx"
									style={{ display: "none" }}
									onChange={(e) =>
										setFiles((prevState) => ({
											...prevState,
											// eslint-disalbe-next-line
											// @ts-ignore
											file: URL.createObjectURL(e.target.files?.[0]),
										}))
									}
								/>
							</div>
						)}
					</div>
				</div>
			</Form>
		</Modal>
	);
};
